var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.announce",
  title: "EGT Announcement Bar",
  description: "Restrained single-line frosted announcement strip rendered ABOVE the nav on every EGT surface. Items come from app/helpers/egt.announcements.js; the client rotates them (7s), picks a random one on load, pauses on hover/focus, shows one static item under reduced motion, and removes the section when nothing is active.",
  supportServer: true,
  fields: {}
});

var Announcements = require("../helpers/egt.announcements.js");

/* N2 — the announcement bar. Inserted by S.page() (app/helpers/egt.sections.js)
 * ABOVE navV2(), so it sits above the brand on every page that renders the EGT
 * chrome. It is a NORMAL block (not sticky): it scrolls away and the sticky nav
 * pins to the top behind it, so it never shifts or clips the nav.
 *
 * Rendered markup: one <ul> with an <li> per ACTIVE item, each carrying its
 * start/end window + href/icon/colour as data-* and its accent inline as
 * --egt-announce-accent. The FIRST active item is marked is-current as the
 * no-JS default; egt.announce.js re-picks a RANDOM one on load and rotates.
 *
 * If NO item is active (all windowed out) this renders NOTHING — an empty
 * string, so no <section> reaches the DOM at all (the client keeps it clean too,
 * in case the window closes between build and view). */
exports.render = async function render() {
  var now = Date.now();
  var items = Announcements.activeItems(now);
  if (!items.length) { return ""; }

  var lis = items.map(function (it, i) {
    var li = {
      n: "li",
      c: "egt-announce__item" + (i === 0 ? " is-current" : ""),
      "data-egt-announce-item": "true",
      "aria-hidden": i === 0 ? "false" : "true",
      style: "--egt-announce-accent: " + (it.colour || "var(--egt-gold)") + ";",
      i: {
        n: "a", c: "egt-announce__link", href: it.href || "#",
        i: [
          { n: "i", c: "bi " + (it.icon || "bi-dot") + " egt-announce__icon", "aria-hidden": "true" },
          { n: "span", c: "egt-announce__text", i: it.text || "" },
          { n: "span", c: "egt-announce__tick", "aria-hidden": "true", i: "›" }
        ]
      }
    };
    /* only stamp the window bounds that exist, so the client's date check has
     * something to read (an omitted bound = open on that side). */
    if (it.start) { li["data-start"] = String(it.start); }
    if (it.end) { li["data-end"] = String(it.end); }
    return li;
  });

  return {
    n: "section", c: "egt-announce", "data-egt-announce": "true",
    role: "region", "aria-label": "Announcements",
    i: { n: "div", c: "egt__shell egt-announce__shell",
      i: { n: "ul", c: "egt-announce__list", i: lis } }
  };
};
